module.exports = __webpack_public_path__ + "static/p01_letrero-f996311fa7c053e6ed361686ef6f7ce8.png";